/* @flow */

import * as React from 'react';

import {colors} from 'shells/colors';
import {AiSparkleNewIcon} from 'shells/icon';
import {StackLegacy} from 'shells/layout';
import {Body} from 'shells/typography';

export function SuggestedReplyLabel() {
    return (
        <StackLegacy spacing={4} isHorizontal={true}>
            <AiSparkleNewIcon color={colors.aiBlue} size={13} />
            <Body size='small' color='navy-dk' isBold={true}>
                Start a reply with AI
            </Body>
        </StackLegacy>
    );
}
